import React, { FunctionComponent, } from 'react';
import {
  Card,
  CardContent,
} from '@mui/material';
import { AppDispatch, } from '../../store/store';
import { useTranslation, Trans } from 'react-i18next';
import { useDispatch, } from 'react-redux';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import { Container } from '@mui/system';
import SuccessMessage from '../../components/SuccessMessage/SuccessMessage';

import './SignUpSuccess.css';
import useTitle from '../../helpers/use-title';


const SignUpSuccess: FunctionComponent = () => {

  const { t } = useTranslation( [ 'signUpSuccess' ] );

  const dispatch = useDispatch<AppDispatch>();

  useTitle( t( 'sendingSuccessful' ) );

  return (
    <AppLayout title={ t( 'your-account' ) }>
      <div className="page page-signup-success">
        <Container>
          <Card sx={ { mt: 4 } }>
            <CardContent>
              <SuccessMessage header={ t( 'sendingSuccessful' ) }>
                <p>
                  <Trans t={t} i18nKey="weSentYouAnEmail">
                    <strong>We sent you an email</strong> to the entered email address. To confirm your email address, go to your mailbox and <strong>click on the button in the email</strong>.
                  </Trans>
                </p>
                { t('for-security-reasons') }
              </SuccessMessage>
            </CardContent>
          </Card>
        </Container>
      </div>
    </AppLayout>
  );
}

export default SignUpSuccess;
